// extracted by mini-css-extract-plugin
export default {"wrapper":"Logo2_wrapper__C5asG","img":"Logo2_img__vVSqH"};